import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomeRoute from 'routes/Home';
import ContactRoute from 'routes/Contact';
import AboutRoute from 'routes/About';
import NotFoundRoute from 'routes/NotFound';


const CoreLayout = () => (
	<Routes>
		<Route path='/' element={<HomeRoute />} />
		<Route path='/contact' element={<ContactRoute />} />
		<Route path='/about' element={<AboutRoute />} />
		<Route path='*' element={<NotFoundRoute />} />
	</Routes>
);


export default CoreLayout;
